export const isDepartmentUser = (userInfo) => (userInfo?.userTypes || []).includes("Department");

export const getAllowedSubsidiaryUuids = (userInfo) => {
  const subsidiaryUuids = Array.isArray(userInfo?.subsidiaryUuids) ? userInfo.subsidiaryUuids.filter(Boolean) : [];
  return subsidiaryUuids;
};

export const getVisibleSubsidiaries = (subsidiaries, userInfo) => {
  const items = subsidiaries || [];
  if (!isDepartmentUser(userInfo)) {
    return items;
  }
  const allowed = new Set(getAllowedSubsidiaryUuids(userInfo));
  return items.filter((subsidiary) => allowed.has(subsidiary.uuid));
};

export const getEffectiveSubsidiary = (subsidiaries, subsidiarySelected, userInfo) => {
  const items = subsidiaries || [];
  if (!isDepartmentUser(userInfo)) {
    return subsidiarySelected?.uuid ? subsidiarySelected : items[0] || {};
  }
  const visibleSubsidiaries = getVisibleSubsidiaries(subsidiaries, userInfo);
  return visibleSubsidiaries.find((subsidiary) => subsidiary.uuid === subsidiarySelected?.uuid) || visibleSubsidiaries[0] || {};
};
